import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import _ from "lodash";
import CKEditor from "react-ckeditor-component";
import renderHTML from "react-render-html";
import {
  get_faq_frontend,
  add_vote,
  get_faq_check_vote
} from "../../../redux/actions/faqAction";
import loader from "../../../style/loader/loader.scss";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

const history = createHashHistory();
class Faq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: "",
      alreadySubmitted: "",
      faqsVoteInfo: {},
      recentlyVoted: [],
      faqDetails: [],
      isLoading: true
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  showAnswer = quesID => e => {
    if (this.state.question === quesID) {
      this.setState({ question: "" });
    } else {
      this.setState({ question: quesID });
    }
  };

  handleClick = (voteParams, quesIDParams) => e => {
    this.props.add_vote({ vote: voteParams, quesID: quesIDParams });
    let votedQuestion = this.state.recentlyVoted;
    votedQuestion.push(quesIDParams);
    this.setState((recentlyVoted: votedQuestion));
  };

  componentWillMount() {
    this.props.get_faq_frontend();
  }
  componentWillReceiveProps(nextProps) {
    if (
      this.props.faqFrontendDetails !== nextProps.faqFrontendDetails &&
      nextProps.faqFrontendDetails.length > 0
    ) {
      this.setState({ faqDetails: nextProps.faqFrontendDetails });
      nextProps.faqFrontendDetails.map((faq, index) => {
        this.props.get_faq_check_vote({ quesID: faq.quesID });
      });
    }
    if (this.props.addFaqVoteResponse !== nextProps.addFaqVoteResponse) {
      if (nextProps.addFaqVoteResponse.response === "success") {
        this.setState({
          alreadySubmitted: nextProps.addFaqVoteResponse.message
        });
      }
    }
    if (this.props.faqVoteDetails !== nextProps.faqVoteDetails) {
      var faqObject = this.state.faqsVoteInfo;
      const quesID = nextProps.faqVoteDetails.data;
      if (!faqObject.hasOwnProperty(quesID)) {
        faqObject[quesID] = nextProps.faqVoteDetails.voted;
      }
      if (_.size(faqObject) === this.state.faqDetails.length) {
        this.setState({ isLoading: false });
      }
      this.setState({ faqVoteDetails: faqObject });
    }
  }

  render() {
    let faqRow;
    if (
      !isEmpty(this.props.faqFrontendDetails) &&
      this.props.faqFrontendDetails.length > 0 &&
      this.props.faqFrontendDetails.length === _.size(this.state.faqsVoteInfo)
    ) {
      faqRow = this.props.faqFrontendDetails.map((faq, index) => (
        <div id={faq.quesID}>
          <h4 onClick={this.showAnswer(faq.quesID)}>
            <i
              className="fa fa-question-circle"
              style={{ marginRight: "11px" }}
              aria-hidden="true"
            />
            {faq.question.charAt(0).toUpperCase() + faq.question.substr(1)}
          </h4>
          {faq.quesID === this.state.question && (
            <div
              style={{
                marginLeft: "25px",
                marginTop: "10px",
                marginBottom: "50px"
              }}
            >
              <div className="answer">{faq.answer}</div>
              {(this.state.alreadySubmitted &&
                this.state.recentlyVoted.indexOf(faq.quesID) > -1) ||
              this.state.faqsVoteInfo[faq.quesID] === "yes" ? (
                <div
                  style={{ float: "right", fontWeight: "bold", color: "grey" }}
                >
                  {this.state.alreadySubmitted &&
                  this.state.recentlyVoted.indexOf(faq.quesID) > -1
                    ? `${this.state.alreadySubmitted}!`
                    : this.state.faqsVoteInfo[faq.quesID] === "yes" &&
                      "Thanks for your feedback!"}
                </div>
              ) : (
                <div style={{ float: "right" }}>
                  <span>Did you find this helpful?</span>
                  &nbsp;
                  <Button
                    bsStyle="info"
                    onClick={this.handleClick("up", faq.quesID)}
                  >
                    <i className="fa fa-1x fa-thumbs-up" />
                    <span>Yes</span>
                  </Button>
                  &nbsp;
                  <Button
                    bsStyle="danger"
                    onClick={this.handleClick("down", faq.quesID)}
                  >
                    <i className="fa fa-1x fa-thumbs-down" />
                    <span>No</span>
                  </Button>
                  &nbsp;
                </div>
              )}
            </div>
          )}
        </div>
      ));
    }
    return (
      <div>
        {this.props.faqFrontendDetails &&
        this.props.faqFrontendDetails.length > 0 ? (
          <div className="container">
            {this.state.isLoading == true ? (
              <div className="loader">
                <p className="loading-message">
                  <i>Loading...</i>
                </p>
                <div className="spinner">
                  <div className="dot1" />
                  <div className="dot2" />
                </div>
              </div>
            ) : (
              ""
            )}
            <div>
              <div className="panel" style={{ marginTop: "40px" }}>
                <header className="panel-heading">
                  Frequently Asked Questions
                </header>
                <div className="panel-body">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <Row>
                      <Col md={12} xs={12}>
                        <div>Click on the questions to view its answer</div>
                        {faqRow}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container">
            <div>
              <div className="panel" style={{ marginTop: "10px" }}>
                <header className="panel-heading">
                  Frequently Asked Questions
                </header>
                <div className="panel-body">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <Row>
                      <Col md={12} xs={12}>
                        <div> No FAQs Exist </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

Faq.propTypes = {
  get_static_page_details: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  faqFrontendDetails: state.faqReducer.faqFrontendDetails,
  addFaqVoteResponse: state.faqReducer.addFaqVoteResponse,
  message: state.alertsReducer.message,
  alertType: state.alertsReducer.alertType,
  error: state.termsPolicyAndContactReducer.error,
  faqVoteDetails: state.faqReducer.faqVoteDetails
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, { get_faq_frontend, add_vote, get_faq_check_vote })
)(Faq);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/Faq.js